<style lang="scss">
.training-enroll-wrapper {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 10000;
    opacity: 0;
    transition: opacity 0.2s, visibility 0s 0.2s;
    visibility: hidden;

    &.visible {
        visibility: visible;
        opacity: 1;
        transition: opacity 0.2s;
    }

    .background {
        background-color: rgba(255, 255, 255, 0.9);
        left: 0;
        top: 0;
    }
}

.training-enroll-modal {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.16);
    border-radius: 4px;
    background-color: #ffffff;
    width: calc(100% - 32px);

    @media screen and (min-width: 768px) {
        width: 712px;
    }

    .close {
        cursor: pointer;
        display: block;
        width: 12px;
        height: 12px;
        position: absolute;
        top: 18px;
        right: 18px;

        &:after {
            content: "";
            background: url("/svg/icons/icon-close-black.svg");
            background-size: 12px 12px;
            position: absolute;
            top: 0;
            left: 0;
            width: 12px;
            height: 12px;
        }
    }

    input {
        min-height: 64px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.15s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
}
</style>
<style lang="scss" scoped>
.checkmark {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    margin-left: 15px;

    &::after {
        content: "";
        display: block;
        width: 10px;
        height: 18px;
        margin-top: -10px;
        border: solid #fff;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
}
</style>

<template>
    <div class="training-enroll-wrapper px-16" :class="{'visible': isVisible}">
        <div class="background position-absolute w-100 h-100">

        </div>

        <div class="training-enroll-modal">
            <div class="modal-inner py-40 px-24 py-md-80 px-md-40 text-center">
                <transition name="fade" tag="div" mode="out-in">
                    <div v-if="step == 0" :key="0">
                        <span class="h2 d-block mb-32">{{ popupTranslations.signup_title }}</span>
                        <p class="font-weight-light mb-32">{{ popupTranslations.signup_description }}</p>
                        <ValidationObserver ref="observer" tag="form" @submit.prevent="submit()">
                            <ValidationProvider ref="email" vid="email" rules="required|email" v-slot="props" :name="translations.email" :slim="true">
                                <div class="form-group position-relative d-flex flex-column flex-md-row mb-0" :class="props.classes">
                                    <input type="email" id="email" class="form-control mr-16 mb-8 mb-md-0" :placeholder="translations.email" v-model="formData.email" />
                                    <button @click.stop="submit(`/training/${$root.trainingEnrollmentId}/enrollment`)" class="btn btn-lg btn-secondary btn-special">
                                        <div class="d-flex">
                                            {{ translations.subscribe }}
                                            <el-loader :loading="processing" class="my-auto ml-16" />
                                            <div v-if="!processing && success" class="my-auto ml-16 checkmark"></div>
                                        </div>
                                    </button>
                                </div>
                                <div class="text-left mt-8"><span class="error">{{ props.errors[0] || compiledErrors[0] }}</span></div>
                            </ValidationProvider>
                        </ValidationObserver>

                        <p class="font-weight-light mt-32 mb-0" v-html="popupTranslations.sub_text"></p>
                    </div>

                    <div v-if="step == 1" :key="1">
                        <span class="h2 d-block mb-32">{{ popupTranslations.confirm_message.title }}</span>
                        <p class="font-weight-light mb-32">{{ popupTranslations.confirm_message.description }}</p>
                        <a href="#" class="btn btn-secondary btn-special" @click.stop="$root.trainingEnrollmentVisible = false"><span>{{ popupTranslations.confirm_message.button }}</span></a>
                    </div>
                </transition>
            </div>

            <span class="close" @click="$root.trainingEnrollmentVisible = false"></span>
        </div>
    </div>
</template>

<script>
import hasErrors from '@mixins/hasErrors'
import disableHtmlScroll from '@mixins/disableHtmlScroll'

export default {
    name: '',

    mixins: [hasErrors, disableHtmlScroll],

    props: {
        portalLink: {
            type: String,
            required: true
        },

        popupTranslations: {
            type: Object,
            required: true
        },

        translations: {
            type: Object,
            required: true
        },

        email: {
            type: String,
        }
    },

    data: vm => ({
        step: 0,

        serverError: null, //stores a server error (with optional message)

        formData: {
            email: vm.email || ''
        },

        processing: false,
        success: false,
    }),

    mounted() {
        var self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            } else {
                isEscape = (evt.keyCode === 27);
            }
            if (isEscape) {
                if (self.$root.trainingEnrollmentVisible) {
                    self.$root.trainingEnrollmentVisible = false;
                }
            }
        };
    },

    methods: {
        async submit(path) {
            const isValid = await this.$refs.observer.validate();
            if (isValid && path != null && path != '') {
                this.processing = true;
                axios
                    .post(path, this.formData)
                    .then((response) => {
                        if (response.data.hasOwnProperty('success')) {
                            this.errors = []
                            this.step = 1;
                            this.sendGaEvent()
                        };
                        this.success = true
                    })
                    .catch((error) => {
                        this.errors = error.response.data.errors
                    })
                    .finally(() => {
                        this.processing = false
                    });
            }
        },
    },

    computed: {
        currentStep() {
            return this.step;
        },

        isVisible() {
            return this.$root.trainingEnrollmentVisible;
        }
    },

    watch: {
        '$root.trainingEnrollmentId': {
            handler: function () {
                this.processing = false
                this.success = false
            }
        },
        isVisible(newValue) {
            if (newValue) {
                return this.opened()
            }
            return this.closed()
        }
    }
}
</script>